import { BreadCrumbModel } from '@/models/breadcrumb';
import i18n from '@/plugins/i18n';

const Breadcrumbs = {
  verifications: [{
    text: i18n.t('furizatBillsVerification'),
    href: '/furijat-verification',
  }] as BreadCrumbModel[],
};

export default Breadcrumbs;
